module.exports = __webpack_public_path__ + "static/z_tall_1800eyedoctor-f2c5a8778fe38ce384ca2a87db16fcb7.jpg";